export default class Oportunidade {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.doadorId = 0;
        this.descricao = '';
        this.valorTotal = 0.00;
        this.probabilidade = 1;
        this.fonte = 0;
        this.status = 'A';
        this.leiIncentivo = 1;
        this.anexo = '';
        this.responsavelId = null;
        this.contatoPrincipalId = null;
        this.previsaoFechamento = null;
        this.versao = 0;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.doadorId = model.doadorId;
        this.doador = model.doador;
        this.descricao = model.descricao;
        this.valorTotal = model.valorTotal;
        this.probabilidade = model.probabilidade;
        this.fonte = model.fonte;
        this.status = model.status;
        this.leiIncentivo = model.leiIncentivo;
        this.anexo = model.anexo;
        this.responsavelId = model.responsavelId == null ? null : model.responsavelId;
        this.contatoPrincipalId = model.contatoPrincipalId == null ? null : model.contatoPrincipalId;
        this.previsaoFechamento = model.previsaoFechamento || null;
        this.versao = model.versao || 0;
    }
}
